import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "template-list-component",
  style: {"width":"100%"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "hover-item" }
const _hoisted_5 = { class: "description-detail" }
const _hoisted_6 = { class: "user-number" }
const _hoisted_7 = { class: "tag-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card_meta = _resolveComponent("a-card-meta")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, { gutter: 16 }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
          return (_openBlock(), _createBlock(_component_a_col, {
            key: item.id,
            span: 6,
            class: "poster-item"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: { name: 'template', params: { id: item.id } }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, { hoverable: "" }, {
                    cover: _withCtx(() => [
                      (item.coverImg)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: item.coverImg
                          }, null, 8, _hoisted_2))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _ctx.DEFAULT_COVER_IMAGE
                          }, null, 8, _hoisted_3)),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_a_button, {
                          size: "large",
                          type: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" 使用该模版创建 ")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_a_card_meta, {
                        title: item.title
                      }, {
                        description: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("span", null, "作者：" + _toDisplayString(item.author), 1),
                            _createElementVNode("span", _hoisted_6, _toDisplayString(item.copiedCount), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["title"])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_7, [
                    (item.isHot)
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 0,
                          color: "red"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" HOT ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (item.isNew)
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 1,
                          color: "green"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" NEW ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}